/**
 * Created by mohit.chavda on 3/7/2017.
 */

import {ONLINE_APP_CONSTANTS} from "../constant/OnlineAppConstants";
import {Injectable} from "@angular/core";
@Injectable()
export class FileValidation {

  validateFile(data, minSize:number, maxSize:number, fileTypeExtensions:string[]):string {
    var fileName = data ? (data.originalName || data.name || '') : '';
    var extensionName = fileName.split('.').pop().toLowerCase();
    var fileSize = data ? data.size : 0;
    var isFileFormatValid = false;
    if (fileTypeExtensions != null) {
      for (var i = 0; i < fileTypeExtensions.length; i++) {
        if (extensionName == fileTypeExtensions[i]) {
          isFileFormatValid = true;
          break;
        }
      }
      if(!isFileFormatValid)
        return ONLINE_APP_CONSTANTS.FILE_FORMAT;
    }
    if (minSize != null && fileSize < minSize) {
      return ONLINE_APP_CONSTANTS.FILE_MIN_SIZE;
    }
    if (maxSize != null && fileSize > maxSize) {
      return ONLINE_APP_CONSTANTS.FILE_MAX_SIZE;
    }
    return ONLINE_APP_CONSTANTS.PASS;
  }
}




// WEBPACK FOOTER //
// ./src/app/common/validation/FileValidation.ts